import { IMapMarker } from "interfaces/components/Map/IMapConfig";
import { IVehiclePaneProps } from "interfaces/components/Map/IVehiclePaneProps";
import { MapMarkerIcon } from "interfaces/components/Map/MapMarkerIcon";
import IActiveSiteModel from "interfaces/IActiveSiteModel";
import IDisposalSiteViewModel from "interfaces/IDisposalSiteViewModel";
import ITrackingVehicleModel from "interfaces/ITrackingVehicleModel";
import IGetActiveVehiclesTrackingResponseModel from "interfaces/Response/IGetActiveVehiclesTrackingResponseModel";
import { VehicleStatusEnum } from "modules/VehicleStatusEnum";

function mapVehicleStatusToIcon(vehicleStatus: string): MapMarkerIcon {
  let vehicleIcon = MapMarkerIcon.Warning;

  switch (vehicleStatus) {
    case VehicleStatusEnum.Active:
      vehicleIcon = MapMarkerIcon.Active;
      break;
    case VehicleStatusEnum.InActive:
      vehicleIcon = MapMarkerIcon.Inactive;
      break;
    case VehicleStatusEnum.Offline:
      vehicleIcon = MapMarkerIcon.Offline;
      break;
    case VehicleStatusEnum.Warning:
      vehicleIcon = MapMarkerIcon.Warning;
      break;
    default:
      break;
  }

  return vehicleIcon;
}

function mapHwrcActiveSitesToMapMarkers(
  activeHwrcSites: IActiveSiteModel[],
  callBackOnClick: (id: number | undefined, title: string) => void
): IMapMarker[] {
  const mapMarkers: IMapMarker[] = [];

  if (activeHwrcSites) {
    activeHwrcSites.forEach((site: IActiveSiteModel) => {
      if (site.latitude && site.longitude) {
        const hwrcSiteMapMarker: IMapMarker = {
          location: {
            latitude: site.latitude!,
            longitude: site.longitude!
          },
          icon: MapMarkerIcon.HwrcSite,
          title: site.name!,
          text: site.name!,
          key: site.id,
          onClick: callBackOnClick,
          details: site.name
        };

        mapMarkers.push(hwrcSiteMapMarker);
      }
    });
  }

  return mapMarkers;
}

function mapDisposalActiveSitesToMapMarkers(
  activeDisposalSites: IActiveSiteModel[],
  callBackOnClick: (id: number | undefined, title: string) => void
): IMapMarker[] {
  const mapMarkers: IMapMarker[] = [];

  if (activeDisposalSites) {
    activeDisposalSites.forEach((site: IActiveSiteModel) => {
      if (site.latitude && site.longitude) {
        const disposalSiteMarker: IMapMarker = {
          location: {
            latitude: site.latitude!,
            longitude: site.longitude!
          },
          icon: MapMarkerIcon.DisposalSite,
          title: site.name!,
          text: site.name!,
          key: site.id,
          onClick: callBackOnClick,
          details: site.name
        };

        mapMarkers.push(disposalSiteMarker);
      }
    });
  }

  return mapMarkers;
}

function mapActiveVehiclesToMapMarkers(
  activeVehicles: IGetActiveVehiclesTrackingResponseModel,
  callBackOnClick: (id: number | undefined, title: string) => void
): IMapMarker[] {
  const mapMarkers: IMapMarker[] = [];

  if (activeVehicles && activeVehicles.vehicles) {
    activeVehicles.vehicles.forEach((vehicle: ITrackingVehicleModel) => {
      if (vehicle.latitude && vehicle.longitude) {
        const vehicleMarker: IMapMarker = {
          location: {
            latitude: vehicle.latitude!,
            longitude: vehicle.longitude!
          },
          icon: mapVehicleStatusToIcon(vehicle.status),
          title: vehicle.name!,
          text: vehicle.name!,
          key: vehicle.id,
          onClick: callBackOnClick,
          details: vehicle
        };

        mapMarkers.push(vehicleMarker);
      }
    });
  }

  return mapMarkers;
}

function getVehicleById(id: number, vehicles: ITrackingVehicleModel[]): IVehiclePaneProps | undefined {
  const model = vehicles.find(v => v.id === id);
  if (model) {
    return {
      name: model.name ?? "",
      status: model.status,
      type: model.type ?? ""
    };
  }

  return undefined;
}

function getDisposalSiteById(id: string, disposalSites: IDisposalSiteViewModel[]): IDisposalSiteViewModel | undefined {
  const model = disposalSites.find(v => v.id === id);
  return model;
}

function getDetailsById(key: string, markers: IMapMarker[]): IMapMarker | undefined {
  const model = markers.find(m => m.key.toString() === key);
  return model;
}

export {
  mapHwrcActiveSitesToMapMarkers,
  mapDisposalActiveSitesToMapMarkers,
  mapActiveVehiclesToMapMarkers,
  getVehicleById,
  getDisposalSiteById,
  getDetailsById
};
